export enum CaloriesCalculationMethod {
  Summation = 0,
  Method449 = 1,
}